import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined"
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined"
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined"
import Chip from "@mui/material/Chip"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"
import { format as formatDate } from "date-fns"

import GlassMixin from "../../../common/components/GlassMixin"
import Row from "../../../common/components/Row"
import { trimLongString } from "../../../common/utils"
import { EVENT_TYPES } from "./EventPopover"
import { getEventCandidateName } from "./utils"

export default function FullCalendarEvent(event) {
  let Icon

  switch (event.event.extendedProps.type) {
    case EVENT_TYPES.bookingLog:
    case EVENT_TYPES.meetingSchedule:
      Icon = CalendarTodayOutlinedIcon
      break
    case EVENT_TYPES.call:
      Icon = PhoneOutlinedIcon
      break
    default:
      Icon = EmailOutlinedIcon
  }

  const candidateName = getEventCandidateName(event.event.extendedProps)

  return (
    <GrayWrapper>
      <Typography variant="h6" title={candidateName}>
        {trimLongString(candidateName, 10)}
      </Typography>
      <Row sx={{ gap: 1, alignItems: "center" }}>
        <TimeChip label={formatDate(event.event.start, "hh:mm aaa")} />
        <IconWrapper>
          <Icon />
        </IconWrapper>
      </Row>
    </GrayWrapper>
  )
}

const GrayWrapper = styled(Row)(({ theme }) => ({
  justifyContent: "space-between",
  alignItems: "center",
  gap: theme.spacing(1),
  paddingInline: theme.spacing(1),
  height: "44px",
  width: "100%",
  minWidth: "135px",
  maxWidth: "100%",
  padding: "16px",
  borderRadius: "16px",
  ...GlassMixin,
  boxShadow: "0 12px 45px rgba(0, 0, 0, 0.15)",
  "&:hover": {
    background: "transparent",
  },
}))

const IconWrapper = styled(Row)(({ theme }) => ({
  justifyContent: "center",
  alignItems: "center",
  width: "30px",
  aspectRatio: "1/1",
  background:
    "linear-gradient(159deg, rgba(137, 47, 206, 1) 3%, rgba(137, 47, 206, 0.8) 100%)",
  backdropFilter: "blur(12px)",
  borderRadius: "6px",
  "& .MuiSvgIcon-root": {
    fill: "white",
    width: "20px",
  },
}))

const TimeChip = styled(Chip)(({ theme }) => ({
  fontSize: "12px",
  fontWeight: 500,
  color: theme.palette.colors.gray600,
  backgroundColor: "white",
  borderRadius: "16px",
  height: "22px",
  "& .MuiChip-label": {
    paddingInline: "6px",
  },
}))
